/* ==========================================================================
   ATELIER SAJADA - Panier

   1. Ouvre le tiroir apres l'ajout d'une box (/?panier=ouvert)
   2. Retire les options dont le produit parent a ete supprime
   3. Vidage du panier

   Le verrouillage visuel des lignes d'options est gere en Liquid dans
   blocks/cart-products.liquid : plus fiable, car cote serveur.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__atsCartBox) return;
  window.__atsCartBox = true;

  var enCours = false;

  /* ---------- ouverture du tiroir ---------- */

  function demandeOuverture() {
    try {
      return new URLSearchParams(window.location.search).get('panier') === 'ouvert';
    } catch (e) {
      return window.location.search.indexOf('panier=ouvert') !== -1;
    }
  }

  function nettoyerUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('panier');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function trouverDrawer() {
    return document.getElementById('cart-drawer')
        || document.querySelector('cart-drawer-component');
  }

  /* Le tiroir est-il actuellement ouvert ? Determine si l'on a le droit
     de prevenir le theme : sur Horizon 4.x, ses composants repondent aux
     evenements du panier en redessinant le tiroir, ce qui le referme. */
  function tiroirOuvert() {
    var dlg = trouverDrawer();
    if (!dlg) return false;
    if (dlg.tagName === 'DIALOG' && dlg.open) return true;
    if (dlg.hasAttribute && dlg.hasAttribute('open')) return true;
    var parent = dlg.closest ? dlg.closest('dialog, theme-drawer') : null;
    return !!(parent && (parent.open || parent.hasAttribute('open')));
  }

  function ouvrir() {
    var bouton = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (bouton) {
      /* toggle : ne jamais cliquer sur un tiroir deja ouvert, on le refermerait */
      if (bouton.getAttribute('aria-expanded') === 'true') return true;
      bouton.click();
      return true;
    }

    var drawer = trouverDrawer();
    if (!drawer) return false;
    if (typeof drawer.open === 'function') { drawer.open(); return true; }
    if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
    var dlg = drawer.querySelector ? drawer.querySelector('dialog') : null;
    if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
    return false;
  }

  function essayerOuvrir(tentative) {
    tentative = tentative || 0;
    if (ouvrir()) { nettoyerUrl(); return; }
    if (tentative < 30) {
      setTimeout(function () { essayerOuvrir(tentative + 1); }, 120);
      return;
    }
    nettoyerUrl();
  }

  /* ---------- nettoyage des options orphelines ---------- */

  function trouverOrphelines(cart) {
    var parents = {};
    var items = cart.items || [];

    for (var i = 0; i < items.length; i++) {
      var ligne = items[i].properties && items[i].properties._box_ligne;
      if (ligne) parents[ligne] = true;
    }

    var aRetirer = [];
    for (var j = 0; j < items.length; j++) {
      var pere = items[j].properties && items[j].properties._box_parent;
      if (pere && !parents[pere]) aRetirer.push(items[j].key);
    }
    return aRetirer;
  }

  function retirer(cles) {
    var suite = Promise.resolve();
    cles.forEach(function (cle) {
      suite = suite.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: cle, quantity: 0 })
        });
      });
    });
    return suite;
  }

  /* ---------- redessin du panier ----------
     On ne remplace JAMAIS le contenu de la section entiere : le tiroir est
     un <dialog> pilote par <theme-drawer> place dans cette section, et le
     remplacer detruit le dialogue ouvert. On echange seulement l'interieur
     des zones de contenu, et on ne previent le theme que tiroir ferme. */

  var ZONES = [
    '.cart-items__wrapper',
    '.cart__summary-totals',
    '#cart-progress-bar'
  ];

  function sectionsDuPanier() {
    var trouvees = [];
    var hotes = document.querySelectorAll('cart-drawer-component, cart-items-component, #cart-drawer');

    for (var i = 0; i < hotes.length; i++) {
      var section = hotes[i].closest('[id^="shopify-section-"]');
      if (!section) continue;

      var nom = section.id.replace('shopify-section-', '');
      var deja = false;
      for (var j = 0; j < trouvees.length; j++) {
        if (trouvees[j].nom === nom) deja = true;
      }
      if (!deja) trouvees.push({ nom: nom, id: section.id });
    }
    return trouvees;
  }

  function prevenirLeTheme() {
    if (tiroirOuvert()) return;
    ['cart:update', 'cart:refresh'].forEach(function (nom) {
      document.dispatchEvent(new CustomEvent(nom, {
        bubbles: true,
        detail: { source: 'ats-cart-box' }
      }));
    });
  }

  function rafraichir() {
    var sections = sectionsDuPanier();

    /* la page n'affiche pas le panier : rien a redessiner */
    if (!sections.length) {
      prevenirLeTheme();
      return Promise.resolve(true);
    }

    var noms = [];
    for (var i = 0; i < sections.length; i++) noms.push(sections[i].nom);

    return fetch('/?sections=' + encodeURIComponent(noms.join(',')), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (rendus) {
        var remplace = false;

        sections.forEach(function (s) {
          var html = rendus[s.nom];
          var hote = document.getElementById(s.id);
          if (!html || !hote) return;

          var doc = new DOMParser().parseFromString(html, 'text/html');

          ZONES.forEach(function (selecteur) {
            var vivantes = hote.querySelectorAll(selecteur);
            var fraiches = doc.querySelectorAll(selecteur);
            var n = Math.min(vivantes.length, fraiches.length);
            for (var i = 0; i < n; i++) {
              if (vivantes[i].innerHTML !== fraiches[i].innerHTML) {
                vivantes[i].innerHTML = fraiches[i].innerHTML;
                remplace = true;
              }
            }
          });
        });

        prevenirLeTheme();
        return remplace;
      })
      .catch(function () { return false; });
  }

  var dernierPassage = 0;

  function verifier() {
    if (enCours) return;
    /* le redessin modifie le DOM et reveille l'observateur :
       on laisse passer un court delai pour eviter les allers-retours */
    if (Date.now() - dernierPassage < 800) return;

    enCours = true;
    dernierPassage = Date.now();

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var orphelines = trouverOrphelines(cart);
        if (!orphelines.length) { enCours = false; return; }

        return retirer(orphelines)
          .then(rafraichir)
          .then(function () { enCours = false; });
      })
      .catch(function () { enCours = false; });
  }

  /* ---------- vidage du panier ---------- */

  function brancherVidage() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ats-cart-clear]');
      if (!btn) return;
      e.preventDefault();

      if (!window.confirm('Vider entierement votre panier ?')) return;

      btn.disabled = true;
      btn.textContent = 'Suppression...';

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      })
        .then(rafraichir)
        .then(function (ok) {
          if (!ok) window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Vider le panier';
        });
    });
  }

  /* ---------- demarrage ---------- */

  function demarrer() {
    verifier();
    brancherVidage();

    if (demandeOuverture()) {
      if (window.customElements && customElements.whenDefined
          && document.querySelector('cart-drawer-component')) {
        customElements.whenDefined('cart-drawer-component')
          .then(function () { essayerOuvrir(0); })
          .catch(function () { essayerOuvrir(0); });
      }
      essayerOuvrir(0);
    }

    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (nom) {
      document.addEventListener(nom, function () { setTimeout(verifier, 400); });
    });

    var cible = document.querySelector('cart-drawer-component, cart-items-component, #cart-drawer, main');
    if (cible && window.MutationObserver) {
      var minuteur = null;
      new MutationObserver(function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(verifier, 500);
      }).observe(cible, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();